import {useTheme} from 'styled-components';
import {CustomIcon, IconNames} from '@guestapp/ui';
import {AmenityItem, AmenityName} from '../styled';

type Props = {
  icon: IconNames;
  name: string;
};

function Amenity({icon, name}: Props) {
  const theme = useTheme();
  return (
    <AmenityItem>
      <CustomIcon
        name={icon}
        size={24}
        color={theme.hasTemplate ? theme.colors.branding.icons : '#777E91'}
      />
      <AmenityName>{name}</AmenityName>
    </AmenityItem>
  );
}
export {Amenity};
